import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "app/store";
import { stampCategories } from "app/assets";
import Constants from "common/constant";
import { btnDelay, usePlaySound } from "common/utils";
import { SelectedImage } from "./types";

interface StampPickerProps {
  onSelect: (stamp: SelectedImage) => void;
  onClose: () => void;
}

export const StampPicker = ({ onSelect, onClose }: StampPickerProps) => {
  const play = usePlaySound();
  const stampAssets = useSelector((state: RootState) => state.config.assets);
  const [selectedCategory, setSelectedCategory] = useState(stampCategories[0]);

  const handleSelectCategory = (category: string) => () => {
    play();
    setSelectedCategory(category);
  };

  const handleSelectStamp = (url: string) => () => {
    btnDelay(() => {
      play();
      onSelect({ id: Date.now(), url, name: "stamp" });
      onClose();
    });
  };

  return (
    <div className="absolute bottom-full left-0 right-0 flex-col-el h-[300px] bg-white overflow-hidden z-10">
      {/* カテゴリ選択 */}
      <div className="flex-row-el shrink-0 w-full overflow-x-auto invisible-scrollbar">
        {stampCategories.map((category, _index) => (
          <div
            key={category}
            onClick={handleSelectCategory(category)}
            className={`flex-col-el flex-center shrink-0 w-[50px] h-[50px] p-[8px] cursor-pointer transition-colors ${
              selectedCategory === category ? "bg-green-alt" : "bg-white hover:bg-green-20"
            }`}
          >
            {stampAssets[category]?.[0] && (
              <img
                alt="カテゴリ"
                src={`${Constants.assetHost}/${stampAssets[category][0].fileKey}`}
                className="w-full h-full object-contain"
              />
            )}
          </div>
        ))}
      </div>

      {/* スタンプ一覧 */}
      <div className="flex-col-el flex-1 w-full overflow-auto p-3">
        <div className="grid grid-cols-[repeat(auto-fill,minmax(120px,1fr))] gap-3 w-full">
          {stampAssets[selectedCategory]?.map((stamp, index) => (
            <div
              key={index}
              onClick={handleSelectStamp(`${Constants.assetHost}/${stamp.fileKey}`)}
              className="flex-col-el flex-center w-[120px] h-[120px] cursor-pointer hover:bg-green-20 rounded-[8px] active:scale-95 transition-all"
            >
              <img
                alt="スタンプ"
                src={`${Constants.assetHost}/${stamp.fileKey}`}
                className="w-full h-full object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
